import { runtimeConfig } from "./config.ts";
import type { PoiDensityAdapter } from "./lib/geo/poi-density/index.ts";
import { jawgPoiDensityAdapter } from "./lib/geo/poi-density/jawg.ts";

export type MapStyle = {
  id: string;
  name: string;
  creator: string;
  styleUrl: string;
  thumbnail: string;
  attributionURL: string;
  // Leave undefined when POI visibility is controlled by layer minzoom.
  // Set an adapter only when the provider uses a style-specific mechanism,
  // such as Jawg's zoomrank filter.
  poiDensityAdapter?: PoiDensityAdapter;
};

const JAWG_ACCESS_TOKEN = runtimeConfig.jawgAccessToken;
const MAPTILER_KEY = runtimeConfig.mapTilerKey;
const TRACESTRACK_KEY = runtimeConfig.tracestrackKey;
const THUNDERFOREST_KEY = runtimeConfig.thunderforestKey;

export const DEFAULT_STYLE_ID = "jawg-streets";

export const STYLES: MapStyle[] = [
  {
    id: "jawg-streets",
    name: "Street",
    creator: "Jawg",
    styleUrl:
      `https://api.jawg.io/styles/jawg-streets.json?access-token=${JAWG_ACCESS_TOKEN}`,
    thumbnail: "/map-style-thumbnails/jawg-streets.webp",
    attributionURL: "https://www.jawg.io/",
    poiDensityAdapter: jawgPoiDensityAdapter,
  },
  {
    id: "carto",
    name: "Carto",
    creator: "Tracestrack",
    styleUrl:
      `https://tile.tracestrack.com/v/maps/carto_v2/style.json?key=${TRACESTRACK_KEY}`,
    thumbnail: "/map-style-thumbnails/tracestrack-carto.webp",
    attributionURL: "https://www.tracestrack.com/",
  },
  {
    id: "streets",
    name: "Streets",
    creator: "MapTiler",
    styleUrl:
      `https://api.maptiler.com/maps/streets-v4/style.json?key=${MAPTILER_KEY}`,
    thumbnail: "/map-style-thumbnails/maptiler-streets.webp",
    attributionURL: "https://www.maptiler.com/",
  },
  {
    id: "openstreetmap",
    name: "OpenStreetMap",
    creator: "MapTiler",
    styleUrl:
      `https://api.maptiler.com/maps/openstreetmap/style.json?key=${MAPTILER_KEY}`,
    thumbnail: "/map-style-thumbnails/maptiler-osm.webp",
    attributionURL: "https://www.maptiler.com/",
  },
  ...(THUNDERFOREST_KEY
    ? [{
      id: "transport",
      name: "Transport",
      creator: "Thunderforest",
      styleUrl:
        `https://api.thunderforest.com/styles/transport/style.json?apikey=${THUNDERFOREST_KEY}`,
      thumbnail: "/map-style-thumbnails/thunderforest-transport.webp",
      attributionURL: "https://www.thunderforest.com/",
    }]
    : []),
  {
    id: "outdoor",
    name: "Outdoor",
    creator: "MapTiler",
    styleUrl:
      `https://api.maptiler.com/maps/outdoor-v4/style.json?key=${MAPTILER_KEY}`,
    thumbnail: "/map-style-thumbnails/maptiler-outdoor.webp",
    attributionURL: "https://www.maptiler.com/",
  },
];
